module.exports = __webpack_public_path__ + "static/media/group-herdies.e09819b6.svg";